import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

const customKeys = [...numbers, 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']

const toNumber = (evt: KeyboardEvent, value?: any): void => {
  const keysAllowed: string[] =
    [...customKeys, ',', '.'];

  const keyPressed: string = evt.key;

  if (!keysAllowed.includes(keyPressed)) {
    evt.preventDefault();
  } else if (value && (String(value).includes('.') || String(value).includes(','))) {
    if((keyPressed === ',' || keyPressed === '.')) {
      evt.preventDefault();
    }
    const dotIndex = String(value).indexOf('.');
    const commaIndex = String(value).indexOf(',');
    const index = commaIndex > dotIndex ? commaIndex : dotIndex;
    if(index > -1 && String(value)?.length - index > 2 && numbers.includes(keyPressed)) {
      evt.preventDefault(); 
    }
  }
}

const formatToMoney = (value: any) => {
  let result = value;
  if(String(value)[0] === ',' || String(value)[0] === '.') { result = `0.${String(result).substring(1)}`}
  if(String(value)[String(value).length-1] === ',' || String(value)[String(value).length-1] === '.') { result = `${String(result).slice(0, -1)}`}
  if(String(value).includes(',')) {
    result = result.replace(',', '.')
  }
  return result
}

const formatCurrency = (number = 0, currencySymbol = '£') =>
  currencySymbol + number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

const toTel = (evt: KeyboardEvent): void => {
  const keysAllowed: string[] =
    [...customKeys, '+', '-'];

  const keyPressed: string = evt.key;

  if (!keysAllowed.includes(keyPressed)) {
    evt.preventDefault();
  }
}

const dateToUTC = (date: Date) => {
  if(!date) return null

  dayjs.extend(utc);

  return dayjs.utc(date).format('YYYY-MM-DDTHH:mm:ss.000000z');
}

const convertMilesToMeters = (miles: number): number => {
  const metersPerMile = 1609.34;
  const meters = miles * metersPerMile;
  return meters;
}

const capitalizeEachWord = (inputString: string) => {
  const words = inputString.split(' ');

  const capitalizedWords = words.map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  const resultString = capitalizedWords.join(' ');

  return resultString;
}

export { toNumber, dateToUTC, convertMilesToMeters, toTel, formatToMoney, capitalizeEachWord, formatCurrency };